import { createFileRoute } from "@tanstack/react-router";
import { ContentPage, ContentProse } from "@/components/content-page";
import { seo } from "@/lib/seo";
import { breadcrumb, webPage } from "@/lib/structured-data";
import { SITE_URL } from "@/lib/seo-constants";

export const Route = createFileRoute("/privacy")({
  head: () =>
    seo({
      title: "Privacy Policy & Data Protection Practices",
      description:
        "How Auxetic Studio collects, uses and protects information when you use Axy.digital.",
      path: "/privacy",
      type: "website",
      jsonLd: [
        webPage({
          name: "Privacy Policy — Axy.digital",
          description:
            "How Auxetic Studio collects, uses and protects information when you use Axy.digital.",
          url: `${SITE_URL}/privacy`,
        }),
        breadcrumb([
          { name: "Home", url: "/" },
          { name: "Privacy Policy", url: "/privacy" },
        ]),
      ],
    }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <ContentPage
      eyebrow="Legal"
      title={
        <>
          Privacy <span className="text-gradient">Policy</span>
        </>
      }
      description="How Auxetic Studio collects, uses and protects information when you use Axy.digital."
    >
      <ContentProse>
        <p>Last updated: 2026.</p>

        <h2>Information we collect</h2>
        <p>
          We collect account information you provide (such as name, email and company), information
          about how you use Axy.digital, and content you connect to the engine (websites, channels,
          documents).
        </p>

        <h2>How we use information</h2>
        <p>
          We use information to operate, secure and improve Axy.digital, generate marketing outputs
          you request, and communicate with you about your account.
        </p>

        <h2>Sharing</h2>
        <p>
          We do not sell personal information. We share data with vetted subprocessors (hosting,
          analytics, AI infrastructure) strictly to deliver the service.
        </p>

        <h2>Your rights</h2>
        <p>
          You can access, export and delete your data at any time. Contact{" "}
          <a href="mailto:privacy@axy.digital">privacy@axy.digital</a> for any privacy request.
        </p>

        <h2>Contact</h2>
        <p>
          Auxetic Studio · <a href="mailto:privacy@axy.digital">privacy@axy.digital</a>
        </p>
      </ContentProse>
    </ContentPage>
  );
}
